import * as React from 'react';
import bindAllOfThis from 'src/utils/BindThisHelper';
import { Layout } from "antd";
import { EnhancedProps } from 'src/pages/student/models/props';

const { Content } = Layout;

export interface Leaving2Props extends EnhancedProps {
}

class Leaving2 extends React.Component<Leaving2Props> {

    constructor(props: Leaving2Props) {
        super(props);
        bindAllOfThis(this, Leaving2.prototype);
    }

    onNext() {
        this.props.onNext();
    }

    componentDidMount() {
        document.body.classList.add("pod-to-station");

        setTimeout(() => {
            this.onNext();
        }, 2500);
    }

    componentWillUnmount(): void {
        document.body.classList.remove("pod-to-station");
    }

    render() {
        let code = this.props.currentPlanet.name.toLowerCase();
        let planetClassName = `planet planet-${code}`;
        let podClassName = `star-pod star-pod-${code}-flipped`;

        return <Content style={{ height: '100vh', overflow: 'hidden' }}>
            <div id="star-pod" className={podClassName} />
            <div id="planet" className={planetClassName} />
        </Content>;
    }
}

export default Leaving2;



// WEBPACK FOOTER //
// ./src/pages/student/scenes/Leaving2.tsx